import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledOtherCostsDataWrapper} from './style'
import {Divider} from '@/components/ui/divider/Divider'

export const DashboardEconomicSummaryCardSkeleton = () => {
    return (
        <Flexbox direction="column" gap={4} fullWidth>
            {/* Secondary data section - Reimbursed accesses and calculated costs */}
            <StyledOtherCostsDataWrapper direction="column" gap={2} fullWidth>
                <Skeleton width="100%" height="32px" />
                <Skeleton width="100%" height="32px" />
            </StyledOtherCostsDataWrapper>

            <Divider direction="horizontal" />

            {/* Primary data - First margin */}
            <StyledOtherCostsDataWrapper fullWidth>
                <Skeleton width="100%" height="40px" />
            </StyledOtherCostsDataWrapper>

            <Divider direction="horizontal" />

            {/* Secondary data - Other costs */}
            <StyledOtherCostsDataWrapper fullWidth>
                <Skeleton width="100%" height="32px" />
            </StyledOtherCostsDataWrapper>

            <Divider direction="horizontal" />

            {/* Primary data - Operating margin */}
            <StyledOtherCostsDataWrapper fullWidth>
                <Skeleton width="100%" height="40px" />
            </StyledOtherCostsDataWrapper>
        </Flexbox>
    )
}
